function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

module.exports = _interopRequireDefault;


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/core/~/recompose/~/@babel/runtime/helpers/interopRequireDefault.js
// module id = 48
// module chunks = 2